import { render, staticRenderFns } from "./label_width_prop_connector.vue?vue&type=template&id=207f896e&scoped=true&lang=pug&"
import script from "./label_width_prop_connector.vue?vue&type=script&lang=js&"
export * from "./label_width_prop_connector.vue?vue&type=script&lang=js&"
import style0 from "./label_width_prop_connector.vue?vue&type=style&index=0&id=207f896e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207f896e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('207f896e', component.options)
    } else {
      api.reload('207f896e', component.options)
    }
    module.hot.accept("./label_width_prop_connector.vue?vue&type=template&id=207f896e&scoped=true&lang=pug&", function () {
      api.rerender('207f896e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/prop_panel/component/label_width_prop_connector.vue"
export default component.exports